import cn from 'classnames';

import * as styles from './styles.css';

export interface IPinCounterProps {
  isHighlighted?: boolean;
  isViewed?: boolean;
}

/**
 * Каунтер мультипина: пилюля с количеством объявлений слева от цены.
 */
export function getCounterRenderer(label: string, { isHighlighted, isViewed }: IPinCounterProps): string {
  return `<div data-testid="pin-counter" class="${cn(
    styles['counter'],
    isHighlighted && styles['active'],
    isViewed && styles['viewed'],
  )}">${label}</div>`;
}
